<template>
  <v-container v-if="product" fluid>
    <h1 class="text-h1 mb-3">{{ product.name }}</h1>
    <v-card class="mb-12">
      <v-card-text>
        {{ $t('product.fields.name') }} : {{ product.name }} <br/>
        {{ $t('product.fields.articleNumber') }} : {{ product.articleNumber }} <br/>
      </v-card-text>
    </v-card>
    <RouterView :client="client" :product="product"/>
  </v-container>
</template>

<script>
import { show as showProduct } from '@/api/endpoints/product.js';
import Product from '@/application/models/product.js';

export default {
  name: 'ProductLayout',
  props: {
    client: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      product: null,
    };
  },
  watch: {
    '$route.params.productId': {
      immediate: true,
      async handler() {
        await this.getProduct();
      },
    },
  },
  methods: {
    async getProduct() {
      const response = await showProduct(this.$route.params.productId);
      this.product = new Product().mapResponse(response.data.data);
    },
  },
};
</script>

<style scoped>

</style>
